import { SelectableMenuItem, PortionItemType, MenuItem, SelectableItemPortion } from '@/models';

export function getPortionMenuItems<T extends MenuItem>(items: MenuItem[], portionType: PortionItemType | 'all'): T[] {
  const filter =
    portionType == 'all'
      ? (i: MenuItem) => i.itemType === PortionItemType.HalfPortion || i.itemType === PortionItemType.ExtraPortion
      : (i: MenuItem) => i.itemType === portionType;

  return items.filter(filter) as T[];
}

export function getSelectablePortionItems<T extends MenuItem>(items: SelectableMenuItem[], portionType: PortionItemType | 'all'): SelectableMenuItem<T>[] {
  const filter =
    portionType == 'all'
      ? (i: SelectableMenuItem) => i.item.itemType === PortionItemType.HalfPortion || i.item.itemType === PortionItemType.ExtraPortion
      : (i: SelectableMenuItem) => i.item.itemType === portionType;

  return items.filter(filter) as SelectableMenuItem<T>[];
}

export function getHalfPortions<TItem extends MenuItem>(items: SelectableMenuItem<TItem>[]): SelectableMenuItem<TItem>[] {
  return getSelectablePortionItems(items, PortionItemType.HalfPortion) || [];
}

export function getExtraPortions<TItem extends MenuItem>(items: SelectableMenuItem<TItem>[]): SelectableMenuItem<TItem>[] {
  return getSelectablePortionItems(items, PortionItemType.ExtraPortion) || [];
}

export function portionItemTypeToItemCardPortion(type: PortionItemType, isCurrentVariant: boolean): SelectableItemPortion | undefined {
  switch (type) {
    case PortionItemType.HalfPortion:
      return SelectableItemPortion.Half;
    case PortionItemType.ExtraPortion:
      return isCurrentVariant ? SelectableItemPortion.Extra : SelectableItemPortion.Single;
    default:
      return undefined;
  }
}
